import { Component, OnInit } from '@angular/core';
import { TooltipService } from '../../../widgets/tooltip.service';
import { AHRService, AuthenticatedIdentity, AuthenticationService, CurrentUser, Option} from 'app/domain'; 
import { Router } from '@angular/router';

@Component({
  selector: 'reviewer-dashboard',
  templateUrl: './reviewer-dashboard.component.html',
  styleUrls: ['./reviewer-dashboard.component.scss']
})
export class ReviewerDashboardComponent implements OnInit {

  currentUser: Option<CurrentUser> = Option.create<CurrentUser>();
  selectedAHRYear: string = 'ALL'; 
  showCaseList = false;

  constructor(
    public tooltipSvc: TooltipService, 
    private authsvc: AuthenticationService, 
    private svc: AHRService, 
    private router: Router) {

        authsvc.currentIdentity.subscribe(identity => {
          identity.match(
            () => {
              this.currentUser = Option.create<CurrentUser>();
            },
            (i: AuthenticatedIdentity) => {
              this.currentUser = Option.create<CurrentUser>(i.user);
            });
        });

   }

  ngOnInit() {
    this.svc.getCurrentPeriodOfReviewYear().then(year => {
      this.selectedAHRYear = year ?? 'ALL';
      this.refreshComponent(year);
    });
  }
  
  getInstructions(): string {
		return this.tooltipSvc.tooltip("WFAPBIngtigrationInstructions.REVIEWER");
	}

  hasInstructions() {
		if (this.getInstructions().length > 0) {
			return true;
		} 
		return false;
	}

  refreshComponent(year: string) {
    this.router.navigate(['/review']);
    this.selectedAHRYear = year;
    this.showCaseList = false;
    setTimeout(() => this.showCaseList = true);  //This refreshes the component
  }
  
  getReviewRange(year: string): string {
    
    if (year === 'ALL') {
      return 'ALL';
    }
  
    const startYear = parseInt(year, 10);

    if (isNaN(startYear)) {
      return year;
    }
  
    return `${startYear}-${startYear + 1}`;
  }
  
}